import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className='not-fount'>
             <img  src='https://i.ibb.co/8cWTz3F/error-404-concept-landing-page-52683-13617.webp'></img>
        </div>
    );
};

export default NotFound;